/* ============================================
   Marquee Announcement Bar — Custom Element
   assets/announcement-bar-marquee.js
   Marquee: pure CSS animation
   JS: sadece countdown + theme editor reload
   ============================================ */

   if (!customElements.get('marquee-announcement-bar')) {
    class MarqueeAnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this._countdownInterval = null;
        this._onSectionLoad = this._onSectionLoad.bind(this);
      }
  
      connectedCallback() {
        document.addEventListener('shopify:section:load', this._onSectionLoad);
        document.addEventListener('shopify:section:reorder', this._onSectionLoad);
        this._initCountdown();
      }
  
      disconnectedCallback() {
        clearInterval(this._countdownInterval);
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
        document.removeEventListener('shopify:section:reorder', this._onSectionLoad);
      }
  
      _onSectionLoad(e) {
        if (e.detail && e.detail.sectionId !== this.dataset.sectionId) return;
        clearInterval(this._countdownInterval);
        this._initCountdown();
      }
  
      _initCountdown() {
        if (this.dataset.showCountdown !== 'true') return;
        const targetStr = this.dataset.countdownTarget;
        if (!targetStr) return;
        const target = new Date(targetStr).getTime();
        if (isNaN(target)) return;
  
        const allWraps = this.querySelectorAll('[data-countdown]');
        if (!allWraps.length) return;
  
        const tick = () => {
          const diff = target - Date.now();
          allWraps.forEach(wrap => {
            if (diff <= 0) { wrap.style.display = 'none'; return; }
            const days    = Math.floor(diff / 86_400_000);
            const hours   = Math.floor((diff % 86_400_000) / 3_600_000);
            const minutes = Math.floor((diff % 3_600_000) / 60_000);
            const seconds = Math.floor((diff % 60_000) / 1_000);
            const q = sel => wrap.querySelector(sel);
            if (q('[data-days]'))    q('[data-days]').textContent    = this._pad(days);
            if (q('[data-hours]'))   q('[data-hours]').textContent   = this._pad(hours);
            if (q('[data-minutes]')) q('[data-minutes]').textContent = this._pad(minutes);
            if (q('[data-seconds]')) q('[data-seconds]').textContent = this._pad(seconds);
          });
        };
  
        tick();
        this._countdownInterval = setInterval(tick, 1000);
      }
  
      _pad(n) { return String(n).padStart(2, '0'); }
    }
  
    customElements.define('marquee-announcement-bar', MarqueeAnnouncementBar);
  }